<template>
  <div class="index-box">
    <van-list
      class="listBoxVan"
      :immediate-check="false"
      v-model="loading"
      :finished="finished"
      finished-text="没有更多了"
      @load="onLoad"
    >
      <div class="listBox">
        <div
          class="journalListCard"
          v-for="(item, index) in journal"
          :key="index"
          @click="journaldetail(item)"
        >
          <div class="card-list__itemone">
            <img class="headDiagram" :src="item.img" />
          </div>
          <div class="card-list__itemtwo">
            <span class="DynamicTitle">{{ item.name }}</span>
            <span class="DynamicTitle-x"
              >{{ item.year }}年第{{ item.number }}期</span
            >
            <span class="DynamicDate">{{ item.updateTime.slice(0, 10) }}</span>
          </div>
        </div>
      </div>
    </van-list>
  </div>
</template>
<script>
export default {
  data() {
    return {
      page: 1,
      pageSize: 8,
      loading: false,
      finished: false,
      journal: [],
    };
  },
  created() {
    this.getJournal();
  },

  methods: {
    // 获取电子期刊
    async getJournal() {
      const result = await this.$http.get("/amJournal/getJournal");
      console.log("获取电子期刊", result.data);
      this.journal = result.data;
    },

    // 懒加载
    onLoad() {
      this.page = this.page + 1;
      this.getJournal();
      this.loading = false;
      // 数据全部加载完成
      if (this.page >= this.lastPage) {
        this.finished = true;
      }
    },

    journaldetail(item) {
      this.id = item.id;
      this.$dialog
        .confirm({
          title: "提示",
          message: "是否进行下载文件？",
        })
        .then(() => {
          this.downPdf();
        })
        .catch(() => {
          // on cancel
        });
    },
  },
};
</script>
<style lang="less" scoped>
.index-box {
  position: relative;
  .listBoxVan {
    position: relative;
    .listBox {
      width: 100vw;
      display: flex;
      flex-direction: column;
      margin-bottom: 20px;
      .journalListCard {
        display: flex;
        width: 90vw;
        background: #fff;
        border-radius: 0.5rem;
        // height: 10rem;
        margin-left: 5vw;
        margin-top: 10px;

        .card-list__itemone {
          flex: 1;
          width: 25vw;
          margin: 5px 0 5px 0;
          margin-left: 5px;
          .headDiagram {
            position: relative;
            // width: 80%;
            // height: 100%;
            z-index: 0;
            // image-rendering: -webkit-optimize-contrast;
            // image-rendering: pixelated;
          }
        }
        .card-list__itemtwo {
          flex: 2;
          margin: 5px 3px 5px 5px;
          display: flex;
          flex-direction: column;
          .DynamicTitle {
            width: 63vw;
            position: relative;
            margin: 5px 5px 0 5px;
            font-size: 1rem;
            font-weight: 600;
            // border: 1px solid #000;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 1;
            overflow: hidden;
            text-overflow: ellipsis;
          }

          .DynamicTitle-x {
            position: relative;
            margin: 5px 5px 0 5px;
            font-size: 0.9rem;
            // font-weight: 600;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 1;
            overflow: hidden;
            text-overflow: ellipsis;
            // height: 65%;
            // border: 1px solid #000;
          }
          .DynamicDate {
            margin-top: 50px;
            padding-left: 5px;
            font-size: 0.8rem;
            color: #a0a0a0;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/alumniHome/Journal.vue